module.exports = __webpack_public_path__ + "img/blockAB21.1efe9546.svg";